import styles from './ForgotForm.scss';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { BaseButton } from '@/components/atoms/button/BaseButton';
import { UseApiContextState } from '@/hooks/api';
import { BaseInput } from '@/components/atoms/input/BaseInput';
import { AuthDialogCard } from '@/components/atoms/card/AuthDialogCard';

type FormProps = JSX.IntrinsicElements['form'];
type Props = Omit<FormProps, 'onSubmit'> & {
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  register: UseFormRegister<ForgetFormValues>;
  errors: FieldErrors<ForgetFormValues>;
};

export type ForgetFormValues = Parameters<UseApiContextState['api']['users']['auth']['password']['$post']>[0]['body'];

/** organisms/ForgotForm */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ForgotForm: React.FC<Props> = ({ children, register, errors, onSubmit, ...props }) => {
  return (
    <AuthDialogCard className="card">
      <form {...props}>
        <BaseInput
          placeholder="メールアドレスを入力"
          type="email"
          error={errors?.email?.message}
          required
          register={register('email')}
        />
        <BaseButton type="submit" className="forgot-button" onClick={onSubmit}>
          送信
        </BaseButton>
      </form>
      <style jsx>{styles}</style>
    </AuthDialogCard>
  );
};
